// Copyright 2017 Brandon Mowat
// Written, developed, and designed by Brandon Mowat for the purpose of helping
// other developers make chat interfaces.
// this is an extension of the package created by the above user
// I've added additional custom bubble components to meet the needs of cy
import * as React from "react";
import BubbleGroup from "../BubbleGroup";
import styles from "./styles";

// React component to render a complete chat feed
export default class ChatFeed extends React.Component {
  /**
   * Determines what type of message/messages to render.
   */
  renderMessages(messages) {
    const {
      bubbleStyles,
      prevMessages,
      submissionError,
      chatBubble,
      errorMessage,
      createdTicket,
      treeStep,
      onClick,
      creatingTicket,
    } = this.props;

    const ChatBubble = chatBubble;

    let group = [];

    const messageNodes = messages.map((message, index) => {
      group.push(message);

      // Find diff in message type or no more messages
      if (
        index === messages.length - 1 ||
        messages[index + 1].userId !== message.userId
      ) {
        const messageGroup = group;
        group = [];

        return (
          <BubbleGroup
            submissionError={submissionError}
            prevMessages={prevMessages}
            creatingTicket={creatingTicket}
            createdTicket={createdTicket}
            errorMessage={errorMessage}
            key={index}
            treeStep={treeStep}
            messages={messageGroup}
            id={message.userId}
            chatBubble={ChatBubble}
            bubbleStyles={bubbleStyles}
            onClick={onClick}
          />
        );
      }

      return null;
    });

    // return nodes
    return messageNodes;
  }

  /**
   * render : renders our chatfeed
   */
  render() {
    return (
      <div id="chat-panel" style={styles.chatPanel}>
        <div
          ref={(c) => {
            this.chat = c;
          }}
          className="chat-history"
          style={{ ...styles.chatHistory }}
        >
          <div className="chat-messages">
            {this.renderMessages(this.props.messages)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HelpWidget/components/ChatFeed/index.jsx